module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fitpanel",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        _vm.scale('Minus');
        _vm.showinfo = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 39.214 39.214"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M52.256,47.635l-8.295-8.295a16.368,16.368,0,1,0-4.621,4.621l8.295,8.295a3.267,3.267,0,0,0,4.621-4.621ZM18.9,30.339A11.437,11.437,0,1,1,30.339,41.776,11.45,11.45,0,0,1,18.9,30.339Z",
      "transform": "translate(-14 -14)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M45.58,33.484a1.658,1.658,0,0,1-1.658,1.658H30.658a1.658,1.658,0,1,1,0-3.316H43.922A1.658,1.658,0,0,1,45.58,33.484Z",
      "transform": "translate(-20.916 -17.11)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fitpaneltext cursor",
    on: {
      "click": function($event) {
        _vm.showinfo = !_vm.showinfo
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.value) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        _vm.scale('Plus');
        _vm.showinfo = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 39.214 39.214"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M52.256,47.635l-8.295-8.295a16.368,16.368,0,1,0-4.621,4.621l8.295,8.295a3.267,3.267,0,0,0,4.621-4.621ZM18.9,30.339A11.437,11.437,0,1,1,30.339,41.776,11.45,11.45,0,0,1,18.9,30.339Z",
      "transform": "translate(-14 -14)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M45.58,37.29a1.658,1.658,0,0,1-1.658,1.658H38.948v4.974a1.658,1.658,0,0,1-3.316,0V38.948H30.658a1.658,1.658,0,1,1,0-3.316h4.974V30.658a1.658,1.658,0,1,1,3.316,0v4.974h4.974A1.658,1.658,0,0,1,45.58,37.29Z",
      "transform": "translate(-20.916 -20.916)"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73df1de3","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/panelFitScreen.vue
// module id = 843
// module chunks = 1 3